import React from 'react';

import FormHeader from 'prequalificationV2/components/FormHeader';
import { maskMonetaryValue } from 'prequalificationV2/utils/stringUtils';
import { getBorrowerFullNames } from 'prequalificationV2/pages/PreQualification/steps/AcceptOffer/AutomatedOffers/acceptAutomatedOffer.utils';

import styles from './PrequalificationOfferHeader.module.scss';

const PrequalificationOfferHeader = ({
  borrowerFirstName,
  borrowerLastName,
  coBorrowerFirstName,
  coBorrowerLastName,
  maxLoanAmount,
  displayId,
}: {
  borrowerFirstName: string;
  borrowerLastName: string;
  coBorrowerFirstName?: string | null;
  coBorrowerLastName?: string | null;
  maxLoanAmount: number;
  displayId?: string | null;
}) => {
  return (
    <>
      <div className={styles.infoContainer}>
        <div className={styles.infoContent}>
          Congratulations{' '}
          {getBorrowerFullNames(borrowerFirstName, borrowerLastName, coBorrowerFirstName, coBorrowerLastName)}
          ! <br />
          You have offers up to <span className={styles.maxLoanAmount}>{maskMonetaryValue(maxLoanAmount)}</span>!
        </div>
      </div>
      <FormHeader
        title={
          <>
            Prequalified: <span className={styles.titleSecondPart}>{maskMonetaryValue(maxLoanAmount)}</span>
          </>
        }
        subtitle={`Inquiry ID: ${displayId}`}
        percent={100}
        step={5}
        totalSteps={4}
      />
    </>
  );
};

export default PrequalificationOfferHeader;
